const getAlumniClassYearsFilter = response => {
  const formattedData = response.data.graduationYear.map(year => ({
    id: year.toString(),
    name: year.toString(),
  }));

  return {
    key: 'alumniClassYears',
    source: 'alumniClassYears',
    filterName: 'Class Years',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getAlumniClassYearsFilter;
